import { render, staticRenderFns } from "./tftDetails.vue?vue&type=template&id=35f70f60&"
import script from "./tftDetails.vue?vue&type=script&lang=js&"
export * from "./tftDetails.vue?vue&type=script&lang=js&"
import style0 from "./tftDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports